import { createContext, useContext } from 'react';

// True for images likely to be above the fold, so they load eagerly instead of lazily.
export const ImagePriorityContext = createContext(false);

export function useImagePriority(): boolean {
  return useContext(ImagePriorityContext);
}
